export default "__VITE_PUBLIC_ASSET__773a90f7__"